import { render, staticRenderFns } from "./CarCanbusData.vue?vue&type=template&id=0d9f5b5f&"
import script from "./CarCanbusData.vue?vue&type=script&lang=js&"
export * from "./CarCanbusData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports